module.exports = __webpack_public_path__ + "static/media/zoom_in_off.01da46bb.svg";